import React, {Component} from 'react';

class PopupPolicy extends Component {
    constructor(props) {
        super(props)
        this.handlePopupPolicy = this.handlePopupPolicy.bind(this);
    }

    handlePopupPolicy() {
        this.props.inactivePopupPolicy(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'text-align': 'center',
                    'width': '337',
                    'height': '315px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.handlePopupPolicy}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h2>Cancellation Policy</h2>
                        <div className="stylulist">
                            <strong>
                                <p>&nbsp;</p>
                                <p>24+ Hours Notice: No Penalty</p>
                                <p>&nbsp;</p>
                                <p>1- 24 Hours Notice: You will be charged 50 % of the total list price</p>
                                <p>&nbsp;</p>
                                <p>&lt;1 Hour Notice: You will be charged 100% of the total list price</p>
                                <p>&nbsp;</p>
                                <p>Cancellation fees will be charged to your Visa or MasterCard</p>
                            </strong>
                        </div>
                    </div>
                    <div className="cta" style={{'display': 'none'}}>
                        <span className="closeModal">Close me</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupPolicy;



/** WEBPACK FOOTER **
 ** ./src/components/PopupPolicy.js
 **/